<template>
  <base-section
    title="よくある質問"
    subtitle="お客様からよくいただくご質問にお答えします"
    background="white"
  >
    <div class="faq-container">
      <div
        v-for="(item, index) in faqItems"
        :key="index"
        class="faq-item"
      >
        <button
          class="faq-item__question"
          :class="{ 'faq-item__question--active': activeIndex === index }"
          @click="toggleAccordion(index)"
        >
          <span class="faq-item__question-text">{{ item.question }}</span>
          <i class="fas fa-chevron-down faq-item__icon"></i>
        </button>
        <transition name="accordion">
          <div
            v-if="activeIndex === index"
            class="faq-item__answer"
          >
            <div class="faq-item__answer-content">
              {{ item.answer }}
            </div>
          </div>
        </transition>
      </div>
    </div>
  </base-section>
</template>

<script>
import BaseSection from '@/components/common/BaseSection.vue';

export default {
  name: 'FAQSection',
  components: {
    BaseSection
  },
  data() {
    return {
      activeIndex: null,
      faqItems: [
        {
          question: '入会金はありますか？',
          answer: 'ございません。まずはお気軽に見学にいらして下さい。'
        },
        {
          question: 'お支払い方法は何ができますか？',
          answer: '指定銀行振込とクレジット決済に対応してます（対応可能カード：VISA,MASTER,JCB,SAISON,AMEX,Diners,DISCOVER）'
        },
        {
          question: 'キャンセルの場合は キャンセル料金はかかりますか？',
          answer: 'はい、かかります。キャンセルするタイミングによってキャンセル料金は変わります。下記をご確認ください。• 8日より前:0% • 7日前〜4日前:25% • 3日前〜前日:50% • 当日:100% ※◯日前というのは23:59分を基準としております。例）1月1日予約の場合、12月31日23:59分までが前日キャンセル、それ以降は当日キャンセルとなります。それ意外のキャンセルに関しても同様となります。'
        },
        {
          question: '予約の時間変更は対応してくれますか？',
          answer: 'はい、当日内の時間変更のみ可能であれば対応させて頂きます。その場合はまずはご相談下さい。日をまたぐ日時の変更はキャンセルポリシーの対象となります'
        },
        {
          question: '領収書はいただけますか？',
          answer: 'クレジット決済の場合、正式な領収書として認められています。銀行振り込みの場合、振込明細書をご利用ください。当社で発行した領収書が必要な場合はお支払い時にお申し出ください。'
        },
        {
          question: 'どのような業種・用途でも申込みは可能ですか？',
          answer: '主にセラピスト、エステティシャン、アイリスト、カウンセラー様にご利用いただいております。スクールや講座のご利用も可能です。ご相談下さい。宗教活動、政治活動、ネットワークビジネスでの利用など利用形態によってはお断りさせていただく場合がございます。※ご利用者様、クライアント様共に女性専用サロンとなります。'
        },
        {
          question: '施術ベッドのサイズと機能を教えてください。',
          answer: 'サイズは 縦幅185cm 横幅70cm です。電動昇降式/ 有孔タイプ（穴あき）'
        },
        {
          question: 'タオルのサイズを教えてください。',
          answer: '上掛けタオル（レンタル無料）→90cm*160cmです。下敷きタオル（レンタル無料）→100cm*170cmです。フェイスタオル（5枚までレンタル無料）→80cm*35cmです。'
        },
        {
          question: '鍵の受け渡しはどのようになりますか？',
          answer: 'ご予約日時が決まりましたら、入退室方法をメールか公式LINEにてお伝え致します。'
        },
        {
          question: '当日の時間延長は出来ますか？',
          answer: 'ご利用日当日での延長の場合は、後の予約が空いている場合のみ可能です。管理者へ必ずご連絡をお願い致します。急な場合連絡がつかない事が御座います。その際は延長は不可とご判断下さい。追加料金のお支払は封筒をご用意しておりますので、お名前・お日にちをご記載頂きボックスの中に入れておいてください。'
        },
        {
          question: '入退室時間について',
          answer: '入室は、前にご予約が入っていない場合は10分前から可能です。原則ご予約時間通りに入退室をお願いいたします（掃除も含めた時間をご予約下さい）前日に管理者よりご予約状況をお伝えします。'
        },
        {
          question: '退出時間を過ぎてしまった場合どうすれば良いですか？',
          answer: 'ご利用時間を超えてご利用になる場合は15分毎の延長料金を頂いております。15分/360円（税込）こちらを封筒をお使い頂き専用ボックスへ入れてください。※入退室時間はセキュリティカメラにて記録されるようになっております。他のご利用者様の迷惑になるような場合はご利用を控えて頂く事がございます。'
        },
        {
          question: '掃除は何をすれば良いですか？',
          answer: 'レンタルサロン使用後は玄関の棚の上にございます「清掃チェックリスト」に基づいて清掃を行っていただいております。掃除漏れや汚れている場合は写真を撮っていただき、清掃チェックリストと一緒にメールまたは公式LINEにてご連絡下さい。'
        },
        {
          question: 'レイアウトを替えても良いですか？',
          answer: '部屋のレイアウトは自由に変更頂いて構いません。ただし、使用後は現状回復をお願い致します。'
        }
      ]
    };
  },
  methods: {
    toggleAccordion(index) {
      this.activeIndex = this.activeIndex === index ? null : index;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/mixins.scss';

.faq-container {
  max-width: 800px;
  margin: 0 auto;
}

.faq-item {
  margin-bottom: $spacing-md;
  background-color: $white;
  border: 1px solid $gray-200;
  border-radius: $radius-lg;
  overflow: hidden;
  transition: all $transition-base;
  
  &:hover {
    box-shadow: $shadow-md;
  }
  
  &__question {
    width: 100%;
    padding: $spacing-lg;
    background: none;
    border: none;
    text-align: left;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: all $transition-base;
    
    &:hover {
      background-color: $gray-100;
    }
    
    &--active {
      background-color: rgba($primary-color, 0.05);
      
      .faq-item__icon {
        transform: rotate(180deg);
        color: $primary-color;
      }
    }
  }
  
  &__question-text {
    font-size: $font-size-lg;
    font-weight: 600;
    color: $gray-900;
    padding-right: $spacing-md;
    
    @include media-breakpoint-down(sm) {
      font-size: $font-size-md;
    }
  }
  
  &__icon {
    flex-shrink: 0;
    color: $gray-500;
    transition: all $transition-base;
  }
  
  &__answer {
    border-top: 1px solid $gray-200;
  }
  
  &__answer-content {
    padding: $spacing-lg;
    font-size: $font-size-md;
    line-height: 1.7;
    color: $gray-700;
    
    @include media-breakpoint-down(sm) {
      font-size: $font-size-sm;
    }
  }
}

// Accordion transition
.accordion-enter-active,
.accordion-leave-active {
  transition: all $transition-base;
  overflow: hidden;
}

.accordion-enter-from,
.accordion-leave-to {
  max-height: 0;
  opacity: 0;
}

.accordion-enter-to,
.accordion-leave-from {
  max-height: 300px;
  opacity: 1;
}
</style>